export type VowelTarget = { letter: string; say: string; hint: string };
export const VOWELS: VowelTarget[] = [
  { letter: "A", say: "AH", hint: "Drop your jaw two fingers wide. Feel the stretch." },
  { letter: "E", say: "EE", hint: "Wide grin — pull the corners of your mouth back." },
  { letter: "I", say: "EYE", hint: "Glide slowly from AH into EE. One long arc." },
  { letter: "O", say: "OH", hint: "Round your lips like an opera singer." },
  { letter: "U", say: "OO", hint: "Push your lips forward into a tight circle." },
];
export const VOWEL_HOLD_MS = 6000;
export const VOWEL_ROUNDS = 2;

export type SyllablePair = { pair: string; muscle: string };
export const SYLLABLES: SyllablePair[] = [
  { pair: "PUH", muscle: "Lips — pop the P like a tiny explosion" },
  { pair: "BUH", muscle: "Lips — voiced this time, keep it punchy" },
  { pair: "TUH", muscle: "Tongue tip — strike just behind your teeth" },
  { pair: "DUH", muscle: "Tongue tip — voiced, crisp, no mumbling" },
  { pair: "KUH", muscle: "Back of tongue — snap it off the soft palate" },
  { pair: "GUH", muscle: "Back of tongue — voiced, keep the volume up" },
];
export const SYLLABLE_TOTAL_MS = 60000;
export const SYLLABLE_SEGMENT_MS = 10000;
export const SYLLABLE_BPM = 140;

export const BREATH = {
  inhaleMs: 4000,
  instructions:
    "One deep breath, then count aloud — 1, 2, 3… — in a smooth, even tone. Stop when you run out of air.",
};

export const TWISTER_REPS = 3;
export const FLUENCY_REPS = 5;

export type DrillId = "vowel" | "syllable" | "breath";
export type Drill = { id: DrillId; name: string; time: string; desc: string };

export const DRILLS: Drill[] = [
  {
    id: "vowel",
    name: "Vowel Stretch",
    time: "~1 min",
    desc: "Exaggerate and hold the five vowels — A E I O U — at a slow, deliberate pace. Two full rounds.",
  },
  {
    id: "syllable",
    name: "Syllable Explosions",
    time: "60 sec",
    desc: "Puh-puh-puh. Buh-buh-buh. Over-articulate every plosive to the beat, louder as you go.",
  },
  {
    id: "breath",
    name: "The Breath Ladder",
    time: "1 breath",
    desc: "One deep breath. Count aloud, smooth and even, as high as you can before the air runs out.",
  },
];
